export default {
	CLEAN: 'LOGINCLEAN',
	LOGOUT: 'LOGINLOGOUT',
    REQUEST_LOGIN: 'LOGINREQUESTLOGIN',
    SET_RETRY_LOGIN: 'LOGINSETRETRYLOGIN',
	SET_LOGIN_SUCCESS: 'LOGINSETLOGINSUCCESS',
	SET_ERROR_MESSAGE: 'LOGINSETERRORMESSAGE'
};